export enum RecurringEmailType {
    Unknown = 0,
    ScheduleCreation = 1,
    NextScheduledDonationDate = 2,
    ThankYou = 3,
    DonationDidNotProcess = 4,
    CancelledDonation = 5,
    RestartedDonation = 6,
}
